import type { RealSpreadsheetId } from '~/_shared/types/spreadsheetData/spreadsheetRow';
import { createStateSelector } from '~/_shared/utils/memoize/createSelector';
import { numberObjectEntries } from '~/_shared/utils/object/objectEnumerators';
import type { RealSpreadsheetVersionId } from '~/spreadsheet/spreadsheet.repository';
import { useSelector } from '../../_shared/utils/hooks/useSelector';
import { type AppState } from '../app.store';

export const spreadsheetDataStateSelector = (state: AppState) => state.spreadsheet.spreadsheetData;

const spreadsheetDataDataSelector = (state: AppState) => state.spreadsheet.spreadsheetData.data;
export const useSpreadsheetDataDataSelector = () => useSelector(spreadsheetDataDataSelector);

const spreadsheetDataLastVersionsSelector = (state: AppState) => state.spreadsheet.spreadsheetData.lastVersions;
const spreadsheetDataLastVersionsPerRealSpreadsheetSelector = createStateSelector(
  spreadsheetDataLastVersionsSelector,
  (lastSpreadsheetVersions) => {
    const versionsPerRealSpreadsheet =
      numberObjectEntries(lastSpreadsheetVersions).reduce((acc, [_, versions]) => {
        numberObjectEntries(versions).forEach(([realSpreadsheetId, version]) => {
          acc.set(realSpreadsheetId, version.versionId);
        });
        return acc;
      }, new Map<RealSpreadsheetId, RealSpreadsheetVersionId>());
    return versionsPerRealSpreadsheet;
  }
);
export const useSpreadsheetDataLastVersionsPerRealSpreadsheetSelector = () => useSelector(spreadsheetDataLastVersionsPerRealSpreadsheetSelector);
